import { Container } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useSettingsContext } from "../settings";

const PageComponent = ({ children }: { children: JSX.Element }) => {

    const settings = useSettingsContext();

    return (
        <>
            <Helmet>
                <title>Gerenciamento Cenix</title>
            </Helmet>
            <Container maxWidth={settings.themeStretch ? false : 'lg'}>                
                {children}
            </Container>
        </>
    );

}

export default PageComponent;